export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-serif font-bold text-midnight-navy mb-8">
          Smarter Systems. <span className="text-wealth-gold">Stronger Operations.</span>
        </h2>
        <div className="space-y-6 text-lg text-slate-gray leading-relaxed">
          <p>
            WealthWiseConsulting partners with service-based businesses to remove operational friction, improve decision-making, and unlock sustainable growth.
          </p>
          <p>
            We don't sell software in isolation. We design intelligent systems aligned to how your business actually operates—so improvements show up in revenue, efficiency, and clarity.
          </p>
        </div>
      </div>
    </section>
  );
}
